module.exports = __webpack_public_path__ + "static/media/icon-ventas.0594cda5.svg";